<template>
  <v-item-group v-model="selected" mandatory class="d-flex">
    <slot></slot>
  </v-item-group>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
  },
  computed: {
    selected: {
      set: function (value) {
        this.$emit('input', value);
      },
      get: function () {
        return this.value;
      },
    },
  },
};
</script>
